<template>
  <empty-page fillHeight pageClass="loginPage">
    <v-layout fill-height column justify-center>
      <div>
        <v-flex xs10 offset-xs1 md6 offset-md3 lg4 offset-lg4>
          <transition name="slide-x-transition" mode="out-in">
            <router-view></router-view>
          </transition>
        </v-flex>
      </div>
    </v-layout>
    <bottom></bottom>
  </empty-page>
</template>

<script>
import Bottom from '../template/Bottom'
export default {
  components: {
    Bottom
  }
}
</script>

<style lang="scss">
.loginPage:before {
  content: '';
  position: fixed;
  width: 100vw;
  height: 100vh;
  background-image: url("/static/img/login-bg.jpg");
  background-position: center center;
  background-repeat: no-repeat;
  background-attachment: fixed;
  background-size: cover;
  -webkit-filter: blur(2px);
  -moz-filter: blur(2px);
  -o-filter: blur(2px);
  -ms-filter: blur(2px);
  filter: blur(2px);
}
</style>
